import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";

const ScreenShot = () => {
  const params = {
    effect: "coverflow",
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    coverflow: {
      rotate: 0,
      stretch: 100,
      depth: 150,
      modifier: 1.5,
      slideShadows: false,
    },
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      361: {
        slidesPerView: 3,
        coverflowEffect: {
          depth: 50,
          modifier: 0,
        },
      },
      601: {
        slidesPerView: 5,
        coverflowEffect: {
          depth: 80,
          modifier: 0,
        },
      },
    },
  };
  return (
    <section id='screenshots' className='theme-bg screenshots'>
      <div className='animation-circle'>
        <i></i>
        <i></i>
      </div>
      <Container>
        <Row>
          <Col md={12} className='text-center'>
            <div className='section-title'>
              <h2 className='text-white'>Chat Loop Screen Shot</h2>
              <img src='assets/images/white-line.png' alt='title-line' className='img-fluid' />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Swiper {...params} className='swiper-screenshots-container-1 swiper-container swiper-container-3d'>
              {[...Array(8).keys()].map((_, i) => (
                <SwiperSlide key={i}>
                  <img src={`assets/images/ss/1.png`} className='img-fluid' alt={`screenshot-${i + 1}`} />
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ScreenShot;
